/**
 *
 */
//$(document).ready(function($){
//     	$(document).on('click', '#client-list .load-summary', function(e){
//		var row = $(e.target).closest('.trow');
//		alert($(row).data('id'));
//		e.stopPropagation();
//	});
//});

var GREEN_BG = '#8acf81',
    GREEN_TOGGLE = '#bbeab4',
    GREY_BG = '#c2c5ca',
    GREY_TOGGLE = '#878c96';

var escapeHTML = function (raw_str) {
  return raw_str ? raw_str.replace(/&(?![#\w]+;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;') : '';
}

var buildAxDialod = function($dialogContainer, title){
  $dialogContainer.dialog({
    dialogClass : 'axDialog dialog',
    closeText : _close_label,
    draggable : false,
    minWidth  : '250',
    minHeight : '250',
    modal     : true,
    resizable : false,
    title     : title,
    width     : '700',
    close     : function(event, ui){
      $dialogContainer.dialog('destroy').remove();
    },
    buttons   : []
  });
}

var appliance_details_upgrade_dialog = function(id, action, label){
  var $start_up_dialog = $('<div id="appliance_details_upgrade_dialog_' + id + '" style="display:none; padding-bottom: 0;"></div>').data('id', id).insertAfter('#content'),
      title = action === 'update' ? (start_upgrade_dialog_title + ' ' + label) : cancel_upgrade_dialog_title,
      deferred = $.Deferred().done(function(){
        buildAxDialod($start_up_dialog, title);
      });

  $start_up_dialog.load(
    '/appliance/appliance_upgrade_dialog/',
    {'id': id, 'action': action},
    function(){
      deferred.resolve();
      var $this = $(this);
      $this.find('#start').click(function() { appliance_details_upgrade([id], -1); });
      $this.find('#cancel_upgrade').click(function() { appliance_details_cancel([id], true); });
      $this.find('#cancel, #continue').click(function(){ $start_up_dialog.dialog('destroy').remove(); });
      $this.find('#contact').click(function(){
        $start_up_dialog.dialog('destroy').remove();
        show_simple_dialog(_contact_support, '/dialog/failover_support');
      });
    }
  );
};

/*
 * Call download function for both single file and multiple files and folders(zipped) from the bridge
 * @param {string} download_info contains filebrowsing download session parameters
 */
function invokeFilebrowsingDownload(download_info) {
  var download_uri = $.base64urlEncode(JSON.stringify(download_info));
  url = "/api/filebrowsing/cloud_download/" + download_uri;
  window.location.href = url;
}

/* Overrides Click Handler for popout on single appliance upgrade
 * Shows popout item "Upgrade Appliance" only when appliance is in a status open to upgrading.
 * If appliance is already in upgrade process, popout item is "Cancel Upgrade"
 */

function singleUpgradeClick(e){
  var self = e.data.self,
			$this = $(this),
      settings = self.options,
      trow = $this.closest('.trow'),
      popoutTemplate = $("#" + settings.popoutTemplate),
      popout = popoutTemplate.clone( true ),
      togglePopout = self.is_popout_active() && trow.is('.activerow');

  self.killpopout();

  if (togglePopout) { e.stopPropagation(); return; }

  popout.attr('id', '').removeClass('popout-template').addClass('popout');
	$this.append(popout);

  var ytarget = trow.position().top + trow.outerHeight();

  popout.css({ 'top' : ytarget, 'right' : 0 });
  popout.show();

  trow.addClass("activerow");

  e.stopPropagation();

  popout.find('.popoutitem').each(function(){
    var $this = $(this), clkHandler = $this.data('clickHandler');
    if (typeof(clkHandler) === 'function') {
      $this.on('click', clkHandler);
    }
  });

  var row = $this.parent(),
      action = row.data('action'),
      upgrade_status = row.data('upgrade_status');
  if (($this.parent().data('upgradable') && (action !=='UPGRADE_NOW')) || (action === 'UPGRADE_CANCEL')) {
     popout.find('#single_upgrade').show();
     popout.find('#single_cancel').hide();
  } else {
    popout.find('#single_upgrade').hide();
    popout.find('#single_cancel').show();
  }
}

/* Overrides Click Handler for multiselect popout on multiple appliance upgrade
 * Options to upgrade, cancel, deselect and update schedule are only available when at least one
 * appliance is selected.
 */
function multiselectUpgradeClick(e){
  var self = e.data.self,
			$this = $(this),
      settings = self.options,
      trow = $this.closest('.trow'),
      multiselectPopoutTemplate = $("#" + settings.multiselectPopoutTemplate),
      popout = multiselectPopoutTemplate.clone( true ),
      togglePopout = self.is_popout_active() && trow.is('.activerow');

  self.killpopout();

  if (togglePopout) { e.stopPropagation(); return; }

  popout.attr('id', '').removeClass('popout-template').addClass('popout');
  $this.append(popout);

	var ytarget = trow.outerHeight();

  popout.css({ 'top' : ytarget, 'right' : 0 });
  popout.show();

  trow.addClass("activerow");

  e.stopPropagation();

  popout.find('.popoutitem').each(function(){
    var $this = $(this), clkHandler = $this.data('clickHandler');
    if (typeof(clkHandler) === 'function') {
      $this.on('click', clkHandler);
    }
  });

  var ids = $("#upgrader-appliance-list").axTable('selected');

  if (ids.length > 0) {
    popout.find('.js-show-if-applicable').show();
  } else {
    popout.find('.js-show-if-applicable').hide();
  }
}

function upgrade_multiple_appliances(id, selected_version, force_upgrade) {
  $("#start").addClass('disabled');
  $.ajax({
    type: "POST",
    url: "/upgrader/upgrader_appliances/upgrade",
    data: {
      id: id,
      selected_version: selected_version,
      force_upgrade: force_upgrade
    },
    dataType : "json",
    success: function(data) {
      if (!data.ok){
        showValidationMessages([], 'upgrader');
        if(data.error_detail){
          $('.error_header .error-detail').html(data.error_detail);
        }
        var cannot_upgrade = jQuery.grep(data.cannot_upgrade, function(n){ return (n); });
        var upgraded = data.upgraded;
        $('#appliances').hide();
        if(upgraded){
          $('#eligible .appliance_list').html(upgraded.join(', '));
          $('#eligible').show();
        }
        $('#ineligible .appliance_list').html(cannot_upgrade.join(', '));
        $('#ineligible').show();
        $('#cancel').hide();
        $('#start').hide();
        $('#okay').show();
        $("#version_dropdown").prop("disabled", true);
      } else {
         $('#okay').click();
      }
    },
    error: function(){
    },
  });
}

function appliance_details_upgrade(id, version){
  $.ajax({
    type: "POST",
    url: "/upgrader/upgrader_appliances/upgrade",
		data: {
			id: id,
			selected_version: version,
			force_upgrade: true
		},
    dataType : "json",
    success: function(data) {
      if (!data.ok){
        $('#start').hide();
        showValidationMessages([], 'appliance_details_upgrade');
        $('#contact').show();
      } else {
         $('#cancel').click();
      }
    },
    error: function(){},
  });
  tabs_goto('appliance/details/'+ id);
}

/*
 * Used both from updater and appliance details page
 */
function appliance_details_cancel(id, refresh){
  $.ajax({
    type: "POST",
    url: "/upgrader/upgrader_appliances/cancel",
    data: {id: id},
    success: function(data) {
      $('#continue').click();
    },
    error: function(){},
  });
  if (refresh){
    tabs_goto('appliance/details/'+ id);
  }
}

var valet_login = function(){
  window.open('http://axcient.net:3000/session/new');
};

var rebootApplianceDialog = function(id, name) {
  var escaped_name = escapeHTML(name),
      title = _appliance_reboot_dialog_title + escaped_name,
      $start_up_dialog = $('<div id="appliance_reboot_dialog_' + id + '" ></div>').data('id', id).insertAfter('#content'),
      deferred = $.Deferred().done(function(){
        buildAxDialod($start_up_dialog, title);
      });
  $start_up_dialog.load(
   '/dialog/appliance_reboot',
   function(){
     deferred.resolve();
     var $this = $(this);
     $this.find('#appliance_reboot').click(function() {
       rebootAppliance(id, name);
       $start_up_dialog.dialog('destroy').remove();
     });
     $this.find('#cancel').click(function() {
       $start_up_dialog.dialog('destroy').remove();
     });
   }
  );
  return deferred;
};

function rebootAppliance (id, name) {
  $.ajax({
    type: "POST",
    url: '/ra/appliance_reboot',
    data: { id: id },
    dataType : "json",
    success: function(data) {
      if(data.result && data.result.ok) {
        var escaped_name = escapeHTML(name);
        var title = _appliance_reboot_dialog_title + escaped_name;
        show_alert_2(title, data.result.msg);
      } else{
        rebootApplianceError(id, name);
      }
    },
    error: function() {
      rebootApplianceError(id, name);
    },
  });
}

var rebootApplianceError = function(id, name) {
  var escaped_name = escapeHTML(name),
      title = _appliance_reboot_dialog_title + escaped_name,
      $start_up_dialog = $('<div id="appliance_reboot_error_dlg_' + id + '" ></div>').data('id', id).insertAfter('#content'),
      deferred = $.Deferred().done(function() {
        buildAxDialod($start_up_dialog, title);
      });
  $start_up_dialog.load(
   '/dialog/appliance_reboot_error',
   function() {
     deferred.resolve();
     var $this = $(this);
     $this.find('#appliance_reboot').click(function() {
       rebootAppliance(id, name);
       $start_up_dialog.dialog('destroy').remove();
     });
     $this.find('#cancel').click(function() {
       $start_up_dialog.dialog('destroy').remove();
     });
   }
  );
};

var checkVOExist = function(client_id, displayErrors = true) {
  var result = true,
      checkUrl = '/cloud_ajax/check_failover_exist';
  $.ajax({
    url: checkUrl,
    type: 'POST',
    data: {"client_id": client_id},
    dataType: 'json',
    async: false,
    success: function(rv, status) {
      if (rv['is_error']) {
        if (displayErrors) {
          handleVOErrors(rv, client_id);
        }
        result = false;
      }
    }
  });
  return result;
}

var handleVOErrors = function(rv, client_id) {
  var detailsUrl = '/client/details/';

  if (rv['errors']['vo_finishing'] !== undefined) {
    tabs_goto(detailsUrl + client_id + '/1');
  } else if (rv['errors']['vo_finished'] !== undefined) {
    show_error(_failover_not_exist_title, rv['errors']['vo_finished']);
    tabs_goto('/client/details/' + client_id);
  }
}

/**
 * nguxSettings page: view - edit - save
 */
window.nguxSettings = window.nguxSettings || {
  helpPaneCss: { edit:{}, save:{}, view:{} }
//  init                : function, grab css for use in animations
//  sectionEdit         : function, going view-edit animation
//  sectionEditSave     : function, going edit-view animation
//  sectionEditCancel   : function, going edit-view animation
}


nguxSettings.init = () => {
  var $tempSettingsSection = $('<div class="tab-content" data-content="settings"><div class="section"><div class="section_help_pane"><div class="status_message"></div></div></div></div>')
          .css({display: 'none'}).appendTo('body'),
      $tempSectionHelpPane = $('.section_help_pane', $tempSettingsSection);

  nguxSettings.helpPaneCss.view.backgroundColor = $tempSectionHelpPane.css('backgroundColor');
  nguxSettings.helpPaneCss.view.color = $tempSectionHelpPane.css('color');
  $tempSectionHelpPane.addClass('editing');
  nguxSettings.helpPaneCss.edit.backgroundColor = $tempSectionHelpPane.css('backgroundColor');
  nguxSettings.helpPaneCss.edit.color = $tempSectionHelpPane.css('color');
  $tempSectionHelpPane.addClass('save');
  nguxSettings.helpPaneCss.save.backgroundColor = $tempSectionHelpPane.css('backgroundColor');
  nguxSettings.helpPaneCss.save.color = $tempSectionHelpPane.css('color');

  $tempSettingsSection.remove();
}

nguxSettings.sectionRefresh = (sctn, id, callback) => {
  if (sctn && id) {
    const section = document.querySelector(`#${sctn} .section_view_content`);
    if (section) {
      $(section).load(`/settings/virtualoffice_settings/load/${id}/${sctn}/view`, callback);
    }
  }
};

nguxSettings.sectionEditRefresh = function(sctn, id, callback) {
	if (sctn && id) {
    const section = document.querySelector(`#${sctn} .section_edit`);
    if (section) {
      $(section).load(`/settings/virtualoffice_settings/load/${id}/${sctn}/edit`, callback);
    }
  }
};

nguxSettings.sectionEdit = e => {
  const button = e.currentTarget,
      controller = button.closest('.section_container').dataset.controller,
      id = button.dataset.id;
  if (button.classList.contains('disabled') || (controller === 'settings/virtualoffice_settings' && !checkVOExist(id))) {
    return;
  }

  const _sctn = button.dataset.sectionName,
      section = document.getElementById(`${_sctn}`),
      $section = $(section);

  //Only one section can be edited at a time
  $(`[data-controller="${controller}"] .edit_button`).addClass('disabled').animate({ opacity: 0 }, function(){
    this.style.display = 'none';
  });

  $('.section_edit', $section).load(`/${controller}/load/${id}/${_sctn}/edit/`, answer => {
    $section.animate({ opacity: 0.5 }, () => {
      $section.animate({ opacity: 1 });
    });
    $('.reset.edit', $section).fadeIn();
    $('[data-event="section-sidebar-btn"]', $section).fadeIn();
    $('.section_edit, .status_message.edit', $section).slideDown(); //can't change to .slideToggle() - got artifacts on jq-1.7.2 with jq-ui-1.8.3
    $('.section_view, .status_message.view', $section).slideUp();
    $('.section_help_pane', $section).animate({
      //backgroundColor: nguxSettings.helpPaneCss.edit.backgroundColor,
      //color: nguxSettings.helpPaneCss.edit.color
    }).addClass('editing unsaved');

    section.querySelector('.cancel_button, .done_button').addEventListener('click', e => {
      nguxSettings.sectionEditCancel(e.currentTarget);
    });

    // handle the answer "You do not have access to perform the requested operation"
    if( $('.error_header', answer ).length ){
      console.log('nguxSettings.sectionEdit Error:', answer );
      setTimeout( () => {
        nguxSettings.sectionEditCancel(section);
      }, 1500 );
    }
  });

  const editComplete = (e, data) => {
    //only allow save once:
    $(".section_view .section_view_content", $section).html(data.data);
    $("html, body").animate({
        scrollTop: $section.offset().top
    }, 500);
    // show .savedAlert, but allocate place for .status_message.view
    $('.status_message.view', $section).css({opacity: 0});
    $('<div class="savedAlert"><span class="icon-lg icon-checkmark-circular left text-primary"></span><span class="left save-text text-primary">' + _section_saved + '</span><span class="clear"></span></div>')
      .hide().prependTo('.section_help_pane.editing.unsaved', $section).fadeIn();
    //prevent double prepend if user clicks twice
    $(".editing.section_help_pane", $section).removeClass('unsaved');

    $section.animate({opacity: 0.5}, () => {
      $section.animate({opacity: 1});
    });
    $('.reset.edit', $section).fadeOut();
    $('.section_edit, .status_message.edit', $section).slideUp();
    $('.section_view, .status_message.view', $section).slideDown();
    $('.section_help_pane', $section).animate({
      //backgroundColor: nguxSettings.helpPaneCss.save.backgroundColor,
      //color: nguxSettings.helpPaneCss.save.color
    }).addClass('save');

    //FIXME - THIS SHOULD BE DONE IN A DEFERRED OBJECT
    setTimeout( () => {
      $('.savedAlert', $section).fadeOut().remove();
      $('.status_message.view', $section).animate({opacity: 1});
      $('.section_help_pane', $section).animate({
        //backgroundColor: nguxSettings.helpPaneCss.view.backgroundColor,
        //color: nguxSettings.helpPaneCss.view.color
      }).removeClass('editing save');

      //Enable all the edit buttons
      $(`[data-controller="${controller}"] .edit_button`).removeClass('disabled').show().animate({opacity: 1});
    }, 1500 );
  };

  $section.one('editing.default.complete', editComplete);
  $section.one('editing.custom.complete', editComplete);

  //track the event
  gtag('event', 'Settings', {
    'event_category': 'Edit',
    'event_label': _sctn
  })
};


nguxSettings.sectionEditCancel = button => {
  const section = button.closest('.section'),
      $section = $(section),
      _sctn = section.dataset.sectionName,
      controller = button.closest('.section_container').dataset.controller;

  $section.animate({ opacity: 0.5 }, () => {
    $section.animate({ opacity: 1 });
  });
  $('.reset.edit', $section).fadeOut();
  $('[data-event="section-sidebar-btn"]', $section).fadeOut();
  $('.section_edit, .status_message.edit', $section).slideUp();
  $('.section_view, .status_message.view', $section).slideDown();
  $('.section_help_pane', $section).removeClass('editing unsaved');

  //Enable all the edit buttons
  $(`[data-controller="${controller}"] .edit_button`).removeClass('disabled').show().animate({ opacity: 1 });

	//track the event
  gtag('event', 'Settings', {
    'event_category': 'Cancel',
    'event_label': _sctn
  });
};


// TODO: refactor internal stuff in section_edit.php views such as saveBind()
//var _section_edit_save = function(sctn,id,values,buttonRef,successCallback) {
nguxSettings.sectionEditSave = (sctn, id, values, successCallback, escape_errors) => {
  $('[data-event="section-sidebar-btn"]').fadeOut();
  let postUrl = '';

  switch (sctn) {
    // appliance settings
    case "thresholds":
    case "network":
    case "softwareupgrade":
    case "unbundledoffsite":
    case "servicesettings":
    case "replibit_servicesettings":
    case "replibit_thresholds":
      postUrl = `/settings/appliance_settings/save/${sctn}`;
      break;
    // reseller settings
    case "reseller_notification_settings":
    case "reseller_thresholds":
		case "reseller_psa_notification_settings":
    case 'reseller_client_health_digest_branding':
    case 'reseller_asio_integration_settings':
      postUrl = `/settings/reseller_settings/save/${sctn}`;
      break;
    // client settings
    case "client_notification_settings":
    case "client_psa_notification_settings":
    case "client_geo_plus_settings":
      postUrl = `/settings/client_settings/save/${sctn}`;
      break;
    // virtual office settings
    case "autostop_vms":
    case "vnetwork":
    case "vpn":
    case "se_vpn":
    case "s2s_vpn":
    case "port_forward":
    case "dhcp":
    case "s2s_ipsec":
      if(!checkVOExist(id)){
        return;
      }
      postUrl = `/settings/virtualoffice_settings/save/${sctn}`;
      break;
    case "vault_thresholds":
    case "vault_settings":
      postUrl = `/settings/vault_settings/save/${sctn}`;
      break;
  }

	// Show the spinner
	if (!values.disabledLoadingMode) {
    document.body.classList.add('loading');
	}

  $.post(postUrl, values, data => {
    document.body.classList.remove('loading');
    if (data.has_error == true) {
      const edit_sctn_el = $(`#${sctn} .section_edit .primary_content`);

      nguxSettings.displayValidationErrors(edit_sctn_el, data.data, escape_errors);
    } else {
      $(`#${sctn}`).trigger('editing.default.complete', [data]);

      if (successCallback) {
        successCallback(data);
      }
    }

    //track the event
    gtag('event', 'Settings', {
      'event_category': 'Save',
      'event_label': sctn
    });

  }, "json");
};

nguxSettings.displayValidationErrors = function(edit_sctn_el, errors, escape_errors, show_message) {
  escape_errors = escape_errors === undefined ? true : escape_errors;
  show_message = show_message === undefined ? true : show_message;
  edit_sctn_el.find(".errormessage,span.field-error,span.error").remove();
  edit_sctn_el.find("input[type=text],input[type=password]").filter('.field-error').removeClass('field-error');
  edit_sctn_el.find(".error-detail").html('');
  for (var item in errors) {
    if (item === '_message_'){
      edit_sctn_el.find('.error-detail').html(escape_errors ? escapeHTML(errors[item]) : errors[item]);
      continue;
    }
    if (edit_sctn_el.find('[validation-errors-inside="' + item + '"]').length > 0) {
      var inputField = edit_sctn_el.find('[validation-errors-inside="' + item + '"]');
      var errorEl = $('<span class="feedback14-icon error" data-axtooltip-class="error" data-axtooltip="'+ errors[item] +'"></span>');
      inputField.append(errorEl);
      continue;
    }
    var input_el = edit_sctn_el.find('[validation-errors-after="' + item + '"]').length
        ? edit_sctn_el.find('[validation-errors-after="' + item + '"]')
        : edit_sctn_el.find('input[name="' + item + '"]');
    if (!input_el.length) {
      input_el = edit_sctn_el.find('input[data-name="' + item + '"]');
    } else if (input_el[0].classList.contains('js-masked-input')) {
      input_el = edit_sctn_el.find('input[name="' + item + '_mask"]');
    }

    if (input_el.length){
      var err_el = $('<span class="feedback16-icon error field-error" data-axtooltip-class="error" data-axtooltip="'+ errors[item] +'"></span>'),
          hlp_el = input_el.parent().children('.helpicon');
      if (hlp_el.length){
        hlp_el.hide();
      }
      input_el.after(err_el);
      if (input_el.is('input[type=text],input[type=password]')){
        input_el.addClass('field-error');
      }
    }
  }
  show_message && edit_sctn_el.find('.error-message').fadeIn();
};

var dashboard_details_click = function(event){
	var id = $(this).closest('.trow').data('id');
	if (typeof(id) == 'undefined'){
		//FIXME - BETTER MESSAGE SHOULD BE DISPLAYED
		show_alert(_error_label, err_operation_failed);
		return false;
	}
	var idx = $('#tabs li.appliances-tab').index();
	$('#tabs').tabs('option', 'active', idx);
	tabs_goto('/appliance/details/' + id, 'li.appliances-tab');
	event.stopPropagation();
};

var clientListActionClick = function (e) {
  var self = e.data.self;
  self.actionCellClick.call(this, e)
  $('#client-list [data-imported_id] .popout :not(.client_details, .client_edit, .client_delete)').remove();
  $('#client-list [data-imported_id][data-allow_edit_lp="false"] .popout').find('.client_edit, .client_delete').remove();
};

var userListActionClick = function (e) {
  var self = e.data.self;
  self.actionCellClick.call(this, e)
  const $currentRow = $(e.currentTarget).parent();
  if (!$currentRow.data('can_be_edited')) {
    $currentRow.find('.popout .user_edit').remove();
  }
  if (!$currentRow.data('can_be_deleted')) {
    $currentRow.find('.popout .user_delete').remove();
  }
};

var vaultListActionClick = function(e) {
	var self = e.data.self,
			$this = $(this),
			rowAttr = e.data.rowAttr,
			settings = self.options,
			$trow = $this.closest('.trow'),
			$popoutTemplate = $("#" + settings.popoutTemplate),
			$popout = $popoutTemplate.clone( true ),
			togglePopout = self.is_popout_active() && $trow.is('.activerow');

	self.killpopout();

	if (togglePopout) {
		e.stopPropagation();
		return;
	}

	$popout.attr('id', '').removeClass('popout-template').addClass('popout');

	if (!rowAttr['dts_enabled']) {
		$popout.find(".vault_login").remove();
	}
  if (rowAttr['tunnel_status'] === '1') {
    const deleteBtnVault = $popout.find(".vault_delete");
    const canForceDelete = deleteBtnVault?.data('can-force-delete');
    if (canForceDelete !== 1) {
      deleteBtnVault.remove();
    }
  }

	$this.append($popout);

	var ytarget = $trow.position().top + $trow.outerHeight();

	$popout.css({ 'top' : ytarget, 'right' : 0 });
	$popout.show();

	$trow.addClass("activerow");

	e.stopPropagation();

	$popout.find('.popoutitem').each(function() {
		var $this = $(this), clkHandler = $this.data('clickHandler');
		if (typeof(clkHandler) === 'function') {
			$this.on('click', clkHandler);
		}
	});
};

var applianceListActionClick = function(e) {
  var self = e.data.self,
			$this = $(this),
      rowAttr = e.data.rowAttr,
      settings = self.options,
      $trow = $this.closest('.trow'),
      $popoutTemplate = $("#" + settings.popoutTemplate),
      $popout = $popoutTemplate.clone( true ),
      togglePopout = self.is_popout_active() && $trow.is('.activerow');

  self.killpopout();

	if (togglePopout) {
		e.stopPropagation();
		return;
	}

  $popout.attr('id', '').removeClass('popout-template').addClass('popout');

  if (rowAttr.can_failover != "1") {
    $popout.find(".appliance_failover").remove();
  }

	if (rowAttr.generation == '4' && !rowAttr['dts_enabled']) {
		$popout.find(".appliance_login").remove();
	}

  if (rowAttr.delete_allowed == "0" || rowAttr.tunnel_status == "1" || rowAttr.generation == "2") {
    $popout.find(".appliance_delete").remove();
  }

  $this.append($popout);

  var ytarget = $trow.position().top + $trow.outerHeight();

  $popout.css({ 'top' : ytarget, 'right' : 0 });
  $popout.show();

  $trow.addClass("activerow");

  e.stopPropagation();

	var prepareHandler = $popout.data('prepareHandler');
	if (typeof(prepareHandler) == 'function') {
		prepareHandler();
	}

  $popout.find('.popoutitem').each(function() {
    var $this = $(this), clkHandler = $this.data('clickHandler');
    if (typeof(clkHandler) == 'function') {
      $this.on('click', clkHandler);
    }
  });
};

var vaultLogin = function (vault_id) {
	if (typeof(vault_id) == 'undefined'){
		_error_dlg(err_operation_failed);
		return false;
	}

	window.open('/vault/login/' + vault_id);
}

var vaultConsole = function (vault_id) {
	if (typeof(vault_id) == 'undefined'){
		_error_dlg(err_operation_failed);
		return false;
	}

	window.open('/vault/console/' + vault_id);
}

var legacy_appliance_login = function(srv_id){
  if (typeof(srv_id) == 'undefined'){
    //FIXME - BETTER MESSAGE SHOULD BE DISPLAYED
    _error_dlg(err_operation_failed);
    return false;
  }

  window.open('/appliance/login/' + srv_id);
};

var legacy_appliance_console = function(srv_id){
  if (typeof(srv_id) == 'undefined'){
    _error_dlg(err_operation_failed);
    return false;
  }

  window.open('/appliance/console/' + srv_id);
};

var replibit_local_machine_login = function(machineId, isVaultMachine = false) {
  if (typeof(machineId) === 'undefined') {
    _error_dlg(err_operation_failed);
    return false;
  }
  var url = '/device/login/' + machineId + (isVaultMachine ? '/1' : '');
  window.open(url);
};

var axTableClientClick = function(event){
  return axTableSecondaryEntityClick(event, 'client_id', '#tabs li.clients-tab', '/client/details/');
};

/* Method for highlighting contents of a specific DOM element.
 * @param {targetId} DOM id of element whose contents will be selected.
**/
var selectElementContents = function(targetId) {
  var range;
  //DOM range implementation varies by browser.
  if(document.selection) {
    range = document.body.createTextRange();
    range.moveToElementText($("#"+targetId)[0]);
    range.select();
  } else if(window.getSelection) {
    range = document.createRange();
    range.selectNodeContents($("#"+targetId)[0]);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
  }
};

var copyElementContents = function(targetId) {
	const input = document.getElementById(targetId);
	const focusToRestore = document.activeElement;
	input.focus();
	input.setSelectionRange(0, input.value.length);
	document.execCommand("copy");
	if (focusToRestore && typeof focusToRestore.focus === "function") {
		focusToRestore.focus();
	}
};

var buildThresholdDialog = (dlg, div_id, tData, getUrl, saveUrl, callbackUrl, saveCallback = null) => {
  const determineMultiplierSelectValue = (multipliersSelect, sliderValue, boundaryValues) => {
    let newSelectedIndex = 0;
    for (let i = 0; i < boundaryValues.length; i++) {
      if (sliderValue >= boundaryValues[i] && (sliderValue % parseInt(multipliersSelect.options[i + 1].value) === 0)) {
        newSelectedIndex = i + 1;
      }
    }

    if (multipliersSelect.selectedIndex !== newSelectedIndex) {
      multipliersSelect.selectedIndex = newSelectedIndex;
      multipliersSelect.dispatchEvent(new Event('manual-change'));
    }
  }

  const determineSliderValueFromInputValue = (inputValue, sliderValues, minuteMap) => {
    let existingValue, value;
    // input value can't be less then first slider value and more than last slider value due to validation, so index always be not undefined
    const indexForSliderValueMoreOrEqualInputValue = minuteMap.findIndex(value => inputValue <= value);
    const sliderValue = sliderValues[indexForSliderValueMoreOrEqualInputValue];

    if (minuteMap[indexForSliderValueMoreOrEqualInputValue] === inputValue) {
      existingValue = true;
      value = sliderValue;
    }
    else {
      existingValue = false;
      value = Math.round((sliderValue + sliderValues[indexForSliderValueMoreOrEqualInputValue - 1]) / 2)
    }

    return {
      existingValue,
      value
    }
  }

  const defaultServerValue = DEFAULT_SERVER_THRESHOLD_VALUE_MINUTES,
      defaultWorkstationValue = DEFAULT_WORKSTATION_THRESHOLD_VALUE_MINUTES,
      defaultLocalThresholdValue = DEFAULT_LOCAL_CACHE_THRESHOLD_VALUE_MINUTES,
      defaultValMap = [_2_hours, _4_hours, _8_hours, _12_hours, _24_hours, _36_hours, _48_hours, _3_days, _7_days,
        _14_days, _1_month, _3_months, _6_months, _1_year],
      localCacheValMap = [_24_hours, _48_hours, _3_days, _7_days, _14_days],
      thresholdVal = tData.threshold,
      vaultThresholdVal = tData.vault_threshold,
      cloudLagVal = tData.cloud_threshold,
      localCacheThresholdVal = tData.local_cache_threshold ? tData.local_cache_threshold.value : defaultLocalThresholdValue,
      isDeviceServer = tData.isDeviceServer,
      overlayWidth = handle => 100 - (parseInt(handle.style.left)) + '%',
      formsToValidate = [];

  //cancel button
  dlg.find('.cancel').click(() => { dlg.dialog('destroy').remove(); });
  dlg.find('[name=is_custom]').change(function() {
    dlg.find('.sliders').slideToggle();
  });

  $('#disable_local_alerts').click(() => {
    $('#local_threshold').toggleClass('disabled');
  });

  $('#disable_vault_alerts').click(() => {
    $('#vault_threshold').toggleClass('disabled');
  });

  $('#disable_cloud_alerts').click(() => {
    $('#cloud_lag_threshold').toggleClass('disabled');
  });

  $('#disable_local_cache_alerts').click(() => {
    $('#local_cache_threshold').toggleClass('disabled');
  });

  dlg.find(".thresholdSlider").each(function() {
    const $this = $(this),
        $sliderBar = $this.find('.sliderBar'),
        sliderId = this.getAttribute('id'),
        input =  $this.find('.sliderDisplay input'),
        hiddenInput = $this.find('.js-threshold_minutes'),
        overlay = $this.find('.overlay'),
        multipliersSelect = this.querySelector('select');

    let setVal;
    let valMap = defaultValMap;
    let minuteMap = DEVICE_AND_JOB_THRESHOLD_SLIDER_VALUES;
    let boundaryValues = DEVICE_AND_JOB_THRESHOLD_SLIDER_BOUNDARY_VALUES;
    switch (sliderId) {
      case 'local_threshold':
        setVal = thresholdVal;
        break;
      case 'cloud_lag_threshold':
        setVal = cloudLagVal;
        break;
      case 'vault_threshold':
        setVal = vaultThresholdVal;
        break;
      case 'local_cache_threshold':
        setVal = localCacheThresholdVal;
        valMap = localCacheValMap;
        minuteMap = LOCAL_CACHE_THRESHOLD_SLIDER_VALUES;
        boundaryValues = LOCAL_CACHE_THRESHOLD_SLIDER_BOUNDARY_VALUES;
        break;
    }

    if (!setVal) {
      setVal = isDeviceServer ? defaultServerValue : defaultWorkstationValue;
    }

    determineMultiplierSelectValue(multipliersSelect, setVal, boundaryValues);
    const inputValueMultiplierObject = {value: parseInt(multipliersSelect.value)};

    const updateInputs = newValue => {
      input.val(newValue / inputValueMultiplierObject.value);
      hiddenInput.val(newValue);
    }

    let initialSliderWidth = $sliderBar.width();

    const sliderAmountMap = [],
        sliderValues = [],
        stepCount = valMap.length,
        stepSum = stepCount * (stepCount - 1) / 2,
        step = Math.floor(initialSliderWidth / stepSum),
        width = step * stepSum;

    $sliderBar.width(width);

    for (let sliderIndex = 0; sliderIndex < stepCount; sliderIndex++){
      sliderAmountMap[sliderIndex] = (sliderIndex + 1) * step;
      sliderValues[sliderIndex] = 0;
      for (let j = 0; j < sliderIndex; j++){
        sliderValues[sliderIndex] += sliderAmountMap[j]
      }
    }

    const initialValueExistingInSliderObject = determineSliderValueFromInputValue(setVal, sliderValues, minuteMap);

    const updateSliderValue = newValue => {
      const valueExistingInSliderObject = determineSliderValueFromInputValue(newValue, sliderValues, minuteMap);
      if (!valueExistingInSliderObject.existingValue) {
        $sliderBar.slider('option', {
          step: 1
        });
      }
      $sliderBar.slider('value', valueExistingInSliderObject.value);
      hiddenInput.val(newValue);
    }

    $sliderBar.slider({
      max: width, // Set "max" attribute to array length
      min: 0,
      value: initialValueExistingInSliderObject.value,
      step: initialValueExistingInSliderObject.existingValue ? step : 1,
      slide: (event, ui) => {
        $sliderBar.slider(
            'option', {
              step: step,
            }
        );
        const index = sliderValues.indexOf(ui.value);
        if (index === -1) {
          return false;
        } else{
          determineMultiplierSelectValue(multipliersSelect, minuteMap[index], boundaryValues);
          updateInputs(minuteMap[index]);
          if (input.valid()) {
            setTimeout(() => { overlay.css({width: overlayWidth($(ui.handle)[0])}); }, 0);
          }
        }
      },
      change: (event, ui) => {
        const index = sliderValues.indexOf(ui.value);
        if (index >= 0) {
          updateInputs(minuteMap[index]);
        }

        setTimeout(() => { overlay.css({width: overlayWidth(ui.handle)}); }, 0);
      }
     });

    const onInputChanged = () => {
      if (input.valid()) {
        const newValueInMinutes = parseInt(input.val()) * inputValueMultiplierObject.value;
        updateSliderValue(newValueInMinutes);
      }
    }

    input.on('input', debounceFunction(() => {
      onInputChanged();
    }, THRESHOLD_SETTINGS_INPUT_DEBOUNCE_MS));

    multipliersSelect.addEventListener('change', () => {
      inputValueMultiplierObject.value = parseInt(multipliersSelect.value);
      onInputChanged();
    });

    multipliersSelect.addEventListener('manual-change', () => {
      inputValueMultiplierObject.value = parseInt(multipliersSelect.value);
    });

    configureThresholdSliderInputValidation($this, minuteMap, valMap[0], valMap[valMap.length - 1], _thresholds_slider_input_validation_message, inputValueMultiplierObject);
    formsToValidate.push($this);

    // GENERATE TICK MARKS
		const tickContainer = $('<div class="flex"></div>');
		$this.append(tickContainer);
    let tick;
    for (let i = 0; i<valMap.length; i++) {
      switch (i) {
        case 0:
          tick = $(`<div class="tick left">${valMap[i]}</div>`);
          tick.width(sliderAmountMap[i] - 1);
          break;
        case Math.ceil(stepCount / 2):
        case stepCount-4:
          tick = $(`<div class="tick">${valMap[i]}</div>`);
          tick.width(sliderAmountMap[i] - 2);
          break;
        case valMap.length-1:
          tick = $(`<div class="tick right"><span class="tick-label-absolute">${valMap[i]}</span></div>`);
          break;
        default:
          tick = $('<div class="tick"></div>');
          tick.width(sliderAmountMap[i] - 2);
      }
			tickContainer.append(tick);
    }

    updateInputs(setVal);

    overlay.css({width: overlayWidth($(this).find('.ui-slider-handle')[0])});
    $('.sliders').css({display: dlg.find('[name=is_custom]:checked').val() === '1' ? 'block' : 'none'});
  });

  //save button
  const $saveButton = dlg.find('.save-threshold'),
      $errorMessage = dlg.find('.infobox--error');
  $saveButton.click(() => {
    $errorMessage.hide();
    if (formsToValidate.some(form => !form.valid())) {
      $errorMessage.fadeIn();
    } else {
      const $thresholdInput = dlg.find('#vault_threshold .js-threshold_minutes'),
          vaultThresholds = $thresholdInput.length ? $thresholdInput.val() : '';
      $.post(saveUrl,
          { id: tData.id,
            machine_id: tData.machineId,
            threshold: dlg.find('#local_threshold .js-threshold_minutes').val(),
            cloud_threshold: dlg.find('#cloud_lag_threshold .js-threshold_minutes').val(),
            vault_threshold: vaultThresholds,
            local_cache_threshold: dlg.find('#local_cache_threshold .js-threshold_minutes').val(),
            enabled: parseInt(dlg.find('[name=is_custom]:checked').val()),
            disable_local_alerts: (dlg.find('#disable_local_alerts').is(':checked')) ? 1: 0,
            disable_cloud_alerts: (dlg.find('#disable_cloud_alerts').is(':checked')) ? 1: 0,
            disable_vault_alerts: (dlg.find('#disable_vault_alerts').is(':checked')) ? 1: 0,
            disable_local_cache_alerts: (dlg.find('#disable_local_cache_alerts').is(':checked')) ? 1: 0
          }, () => {
            dlg.dialog('destroy').remove();
            $.post(getUrl, {id: tData.id}, () => {
              if (saveCallback) {
                saveCallback();
              } else {
                tabs_goto(callbackUrl + tData.id);
              }
            }, 'json');
          });
    }
  });
};

var openAxDialog = function(dlg, div_id, title, width) {
  dlg.dialog({
    dialogClass : 'axDialog dialog',
    closeText : _close_label,
    draggable : false,
    minWidth  : '600',
    minHeight : '250',
    width     : width,
    modal     : true,
    resizable : false,
    title     : title,
    close     : function(event, ui){
      $('#' + div_id).dialog('destroy').remove();
    }
  }).dialog('open');
};

var openDialogHandler = function(){
  var linkElement = arguments[0],
   callFunction = arguments[1],
   args = Array.prototype.slice.call(arguments, 2);
  linkElement.addClass('disabled');
  var df = callFunction.apply(this, args);
  df.done(function(){
    linkElement.removeClass('disabled');
  });
};

const openDialogHandlerWCL = function() {
  const linkElement = arguments[0],
    callFunction = arguments[1],
    args = Array.prototype.slice.call(arguments, 2);
  const button = linkElement[0].currentTarget;
  button.disabled = true;
  const df = callFunction.apply(this, args);
  df.done(function(){
    button.disabled = false;
  });
};

loadDialogContainer = function(options){
  this.defer = $.Deferred();
  this.divId = options.divId;
  this.settingsUrl = options.getSettingsUrl;
  this.templateName = options.templateName;
  this.templatePath = options.templatePath;
  this.buildDialog = options.buildDialog;
  this.title = options.title;
  this.dialogParams = options.dialogParams;
  this.saveUrl = options.saveUrl;
  this.callbackUrl = options.callbackUrl;
  this.dialogWidth = options.dialogWidth || '680'
  this.saveCallback = options.saveCallback;

  var dialogContainer = this;

  this.build = function(){
    if(!window.cachedAxTemplates[dialogContainer.templateName]) {
      $.ajax({
        url: dialogContainer.templatePath,
        success: function (template) {
          window.cachedAxTemplates[dialogContainer.templateName] = template;
          dialogContainer.loadData();
        }
      });
    } else{
      dialogContainer.loadData();
    }
    return dialogContainer.defer;
  }

  this.loadData = function(){
    $.ajax({
      type: 'GET',
      url: dialogContainer.settingsUrl,
      dataType: 'json',
      success: function(rv){
        dialogContainer.loadDialog(rv);
      }
    });
  };

  this.loadDialog = function(data){
    $.each(this.dialogParams, function(param, value){
      data[param] = value;
    });
    var template = window.cachedAxTemplates[dialogContainer.templateName],
        html = Handlebars.compile(template)(data),
        dlg = $('<div id="' + dialogContainer.divId + '" style="display:none;  padding-bottom: 0">' + html + '</div>');

    $('#content').after(dlg);
    dialogContainer.buildDialog(dlg, dialogContainer.divId, data,
     dialogContainer.settingsUrl, dialogContainer.saveUrl, dialogContainer.callbackUrl, dialogContainer.saveCallback);
    openAxDialog(dlg, dialogContainer.divId, dialogContainer.title, dialogContainer.dialogWidth);
    dlg.find('select:not(".without-combobox")').combobox({readonly: true});
    dialogContainer.defer.resolve();
  }
}

var show_job_threshold = function(jobId, jobName, serviceId, machineId, jobOffsite) {
  var loadContainer = new loadDialogContainer({
    getSettingsUrl : '/job/job_threshold_settings/' + jobId,
    templateName : 'job_threshold',
    templatePath : '/template/job-threshold-dialog',
    divId : 'job_threshold_dlg_' + jobId,
    buildDialog : buildThresholdDialog,
    title : _job_details_threshold_title,
    dialogParams : {id: jobId, serviceId: serviceId, jobName: jobName, machineId: machineId, jobOffsite: jobOffsite},
    saveUrl : '/job/save_job_threshold',
    callbackUrl : '/job/details/',
    dialogWidth: '780'
   }
  );
  return loadContainer.build();
};

var show_job_threshold_replibit = function(jobId, jobName, serviceId, machineId, replibitJobType) {
  var loadContainer = new loadDialogContainer({
      getSettingsUrl : '/job/job_threshold_settings/' + jobId,
      templateName : 'job_threshold',
      templatePath : '/template/job-threshold-dialog-replibit',
      divId : 'job_threshold_dlg_' + jobId,
      buildDialog : buildThresholdDialog,
      title : _job_details_threshold_title,
      dialogParams : {id: jobId, serviceId: serviceId, jobName: jobName, machineId: machineId, replibitJobType: replibitJobType},
      saveUrl : '/job/save_replibit_job_threshold',
      callbackUrl : '/job/details/',
      dialogWidth: '780'
    }
  );
  return loadContainer.build();
};

var show_device_threshold = function(deviceId, deviceName, clientId, serviceId, serviceGeneration, d2cDevice, deviceType, resellerId = 0, saveCallback = null) {
  const isD2CDevice = d2cDevice === true || d2cDevice === "1";
  var loadContainer = new loadDialogContainer({
    getSettingsUrl : '/device/device_threshold_settings/' + deviceId,
    templateName : isD2CDevice ? 'device_threshold_d2c' : serviceGeneration == 4 ? 'device_threshold_replibit' : 'device_threshold',
    templatePath : isD2CDevice ? '/template/device-threshold-dialog-replibit-d2c' :
        serviceGeneration == 4 ? '/template/device-threshold-dialog-replibit' : '/template/device-threshold-dialog',
    divId : 'device_threshold_dlg_' + deviceId,
    buildDialog : buildThresholdDialog,
    title : _device_details_threshold_title,
    dialogParams : {id : deviceId, clientId : clientId, deviceName : deviceName, serviceId : serviceId, resellerId: resellerId, d2c : isD2CDevice, isDeviceServer : deviceType === "SERVER"},
    saveUrl : '/device/save_device_threshold',
    callbackUrl : '/device/details/',
    dialogWidth: '780',
    saveCallback: saveCallback
   }
  );
  return loadContainer.build();
};

/**
 * Creates simple dialog window with Close button only
 */
var show_simple_dialog = function(title, url) {
  show_alert_ajax(
    title,
    url,
    { buttons : [{
        text: _close_window_label,
        class: "single-close-btn",
        click: function(){ $(this).dialog('destroy').remove(); }
    }]}
  );
};

var buildCombobox = function(parent, selector, selectCallback, edgeValue, listSelector, warningContainer) {
  parent.find(selector).combobox({ readonly: true,
    select: function (event, ui) {
      if (selectCallback && edgeValue && listSelector) {
        selectCallback(parent, ui, edgeValue, listSelector, warningContainer);
      }
    }
  });
};

$(document).ready(function($){
  var $navLi = 	$(".navigation li");
	// May look crazy but it's like this because it works the best
	$navLi.addClass("middlenav");
	$(".navigation li:first").removeClass("middlenav").addClass("rootnav");
	$(".navigation li:last").removeClass("middlenav").addClass("lastnav");
	$navLi.eq(1).addClass("secondnav");

	// bind header row click for collapsible feeds
  $(document).on('click', '.collapsible-feed > .header, .collapsible', function(){

    var element = $(this),
        content = element.next();

    if (element.is('.expanded')) {
      content.slideUp(200);
    } else {
      content.slideDown(400);
    }
    element.toggleClass('expanded');
  });

	$('#tabs').on('click', '.navigation li .dropdownimg', function(e){

		var dropdownstate = $(this).siblings(".dropdownitems:visible").length;
		$('#tabs').find(".dropdownitems").hide();

		if(dropdownstate){
			$(this).siblings(".dropdownitems").hide();
		}else{
		  var width = Math.max(134, $(this).parent().width() + 19);
	    $(this).siblings(".dropdownitems").width(width);
			$(this).siblings(".dropdownitems").show();
		}


		e.stopImmediatePropagation();
	});

	$("html").click(function(){
	  $(".dropdownitems").hide();
	});

  nguxSettings.init();
  var $content = $('#content');

  //_bind_tooltip_events
  $content.on('blur', '.edit_field', function(){ $(this).nextAll('.tooltip').hide(); });
  $content.on('focus', '.edit_field', function(){ $(this).nextAll('.tooltip').show(); });


  $("#feedbacktosupport").click(function(){
    $('#feedback_dlg').dialog("close");
    angular.element($("[dialogname=mydialog]")[0]).scope().toggleDialog();
  });

});

/**
 * Simulates shaking effect
 * @param intShakes number of movements
 * @param intDistance shake distance
 * @param intDuration shake duration
 * @returns {*}
 */
jQuery.fn.shake = function(intShakes, intDistance, intDuration) {
  this.each(function() {
    $(this).css({ position: "relative" });
    for (var x = 1; x <= intShakes; x++) {
      $(this).animate({
        left: (intDistance * -1)
      }, (((intDuration / intShakes) / 4))).animate({
          left: intDistance
        }, ((intDuration / intShakes) / 2)).animate({
          left: 0
        }, (((intDuration / intShakes) / 4)));
    }
  });
  return this;
};

/**
 * This singleton handles long-polling for real-time UI updates
 */
var pollMeister = new function(){
  var self = this,
      subscriptionData = {},
      subscriptionCallback = {},
      currentPollRequest = null;

  this.subscribe = function (eventId, callback, subscribeData){
    if (subscriptionData[eventId]){
      // resubscribe: update and invoke the callback
      subscriptionCallback[eventId] = callback;
      if (callback){
        callback(subscriptionData[eventId]);
      }
    } else {
      subscriptionData[eventId] = subscribeData;
      subscriptionCallback[eventId] = callback;
      self.poll();
    }
  };
  this.unsubscribe = function (eventId){
    delete subscriptionData[eventId];
    delete subscriptionCallback[eventId];
    self.poll();
  };
  this.mute = function (eventId){
    // poll for data but don't invoke the callback anymore
    subscriptionCallback[eventId] = null;
  };

  this.getEventData = function (eventId){
    return subscriptionData[eventId];
  };

  // stop any existing poll request, then create a poll request (if any request is needed)
  this.poll = function (){
    if (currentPollRequest){
      currentPollRequest.abort();
      currentPollRequest = null;
    }
    if ($.isEmptyObject(subscriptionData)){
      return;
    }
    currentPollRequest = $.ajax({
      type: "POST",
      url: "/pollmeister/fivethousand",
      data: JSON.stringify(subscriptionData),
      success: function (response) {
        currentPollRequest = null;
        for (var i in response){
          subscriptionData[i] = response[i];
          if (subscriptionCallback[i]){
            subscriptionCallback[i](response[i]);
          }
        }
        setTimeout(function () { if (!currentPollRequest) self.poll(); }, 2000 * 10);
      },
      dataType: "json",
      contentType: "application/json"
    }).fail(function (jqXHR, textStatus, errorThrown){
      // unsubscribe everything
      console.log(errorThrown);
      currentPollRequest = null;
      subscriptionData = {};
      subscriptionCallback = {};
    });
  };
}();


/**
 * Handlebars template fetcher / cacher singleton
 */
var templateFetcherSingleton = new function (){
  var templates = {};
  this.fetchTemplates = function (templateNames, onReady){
    if (!Array.isArray(templateNames)){
      templateNames = [templateNames];
    }
    for (var i = templateNames.length; i >= 0; i--){
      if (templates[templateNames[i]]){
        templateNames.splice(i, 1);
      }
    }
    if (templateNames.length){
      $.ajax({
        type: "POST",
        url: "/template",
        data: JSON.stringify(templateNames),
        success: function (data) {
          for (var i = 0; i < data.length; i++){
            templates[templateNames[i]] = Handlebars.compile(data[i]);
          }
          if (onReady){
            onReady();
          }
        },
        dataType: "json",
        contentType: "application/json"
      });
    } else if (onReady){
      onReady();
    }
  };
  this.renderTemplate = function (templateName, data){
    return templates[templateName](data);
  };
}();

var newestClientOverviewManager = null;
function ClientOverviewManager(el){
  var self = this;

  this.renderData = {
    dataLocalShares   : null,
    dataCloudShares   : null,
    dataNewDevices    : null,
    templatesLoaded   : false
  };

  this.isActive = function () {
    // must be active on init, but might be removed from DOM when page closes
    return $.contains(document.documentElement, el[0]);
  };

  this.init = function(){
    templateFetcherSingleton.fetchTemplates(
      ["client-local-shares",
      "client-cloud-shares",
      "no-activities",
      ], function () {
      self.renderData.templatesLoaded = true;
      self.renderIfReady();
    });

    this.fetchCifsShares();
    this.fetchCloudShares();
  };

  this.fetchCifsShares = function(){
    // the backend implementation may contact the appliance, so we do not want to set this up for polling
    $.get('/client/get_exposed_cifs_shares/' + el.data('clientId'), function (response){
      self.renderData.dataLocalShares = response;
      self.renderIfReady();
      timeLeft();
    });
  }

  this.fetchCloudShares = function(){
    $.get('/client/get_cloud_recovery_links/' + el.data('clientId'), function (response){
      self.renderData.dataCloudShares = response;
      self.renderIfReady();
      timeLeft();
    });
  }

  // render activities of interest if all the data is ready
  this.renderIfReady = function (){
    if (!this.isActive()) return;
    if (this.renderData.dataLocalShares === null
     && this.renderData.dataCloudShares === null
     && this.renderData.dataNewDevices === null)
      return;
    if (!this.renderData.templatesLoaded) return;
    this.renderActivities();
  };

  this.renderActivities = function (){
    // eventually, all activites will be handled client-side, and we will be able to remove all old feed rows
    el.find(".feed-table-interest .nothingrecent").remove();
    el.find(".feed-table-interest .local_shares").remove();
    el.find(".feed-table-interest .cloud_shares").remove();

    // render local shares
    if (this.renderData.dataLocalShares && this.renderData.dataLocalShares.length){
      el.find('.feed-table-interest').append( templateFetcherSingleton.renderTemplate("client-local-shares", {shares : this.renderData.dataLocalShares, clientId : el.data('clientId')}) );
      el.find('.header.grey.expanded').removeClass('grey');
      el.find('.activity.bottom').insertAfter('.deviceinfo_bar').removeClass('bottom').addClass('top');

      el.find('.js-cifs_path').click(function () {
          var _this = $(this);
          if (_this.hasClass('disabled'))
            return;
          _this.addClass('disabled');
          var txt = _this.text();
          _this.text(_this.data('busyText'));

          var sid = $(this).data('shareId');
          $.get('/share/display_cifs_share_path/' + sid, function (response) {
            var body = 'For Windows:</br>' + response.dialogMsg + '</br></br>For Mac:</br> ' + response.smbPath;
        	  show_info(response.dialogTitle, response.dialogHeader, body);
            if (response.ok) {
              _this.text(txt);
              _this.removeClass('disabled');
            } else {
              _this.text(_this.data('errorText'));
            }
          });
      });

      el.find('.js-cifs_supress').click(function () {
        var _this = $(this);
        if (_this.hasClass('disabled'))
          return;
        _this.addClass('disabled');
        _this.text(_this.data('busyText'));

        var sid = $(this).data('shareId');
        $.get('/share/suppress_cifs_share/' + sid, function (response) {
          show_alert_2(response.dialogTitle, response.dialogMsg);
          if (response.ok) {
            var parentRow = _this.parents('tr');
            if(parentRow.siblings().length > 0) {
              parentRow.remove();
            } else {
              self.fetchCifsShares();
            }
          }
          else
            _this.text(_this.data('errorText'));
        });
      });
    }

    // render cloud shares
    var cloudShares = this.renderData.dataCloudShares;
    if (cloudShares && Array.isArray(cloudShares) && cloudShares.length){
      el.find(".feed-table-interest .cloud_shares").remove();
      el.find('.feed-table-interest').append( templateFetcherSingleton.renderTemplate("client-cloud-shares", {shares : this.renderData.dataCloudShares, clientId : el.data('clientId')}) );
      el.find('.header.grey.expanded').removeClass('grey');
      el.find('.activity.bottom').insertAfter('.deviceinfo_bar').removeClass('bottom').addClass('top');

      el.find('.js-cloud-link').click(function () {
        var _this = $(this);
        if (_this.hasClass('disabled'))
          return;
        _this.addClass('disabled');
        var txt = _this.text();
        _this.text(_this.data('busyText'));

        var shareId = $(this).data('shareId');
        // make flow container, then insert step container
        var flowcontainer = $("<div>").attr("data-flow-name", "recovery").css('height', '0px');
        $("#content").prepend(flowcontainer);
        var stepcontainer = $("<div>").attr("class", "stepcontainer");
        flowcontainer.append(stepcontainer);
        stepcontainer.load('/client/load_cloud_link/'+shareId, function(){
          if(shareId){
            _this.text(txt);
            _this.removeClass('disabled');
          } else {
            _this.text(_this.data('errorText'));
          }
        });
      });

      el.find('.js-load-expire-cloud-link').click(function () {
        var _this = $(this);
        if (_this.hasClass('disabled'))
          return;
        _this.addClass('disabled');
        var txt = _this.text();
        _this.text(_this.data('busyText'));

        var sid = $(this).data('shareId');
        var flowcontainer = $("<div>").attr("data-flow-name", "recovery").css('height', '0px');
        $("#content").prepend(flowcontainer);
        var stepcontainer = $("<div>").attr("class", "stepcontainer");
        flowcontainer.append(stepcontainer);
        stepcontainer.load('/dialog/expire_cloud_link', function(){
          $(document).on('click', '[data-flow-close="1"]', function(){
            $('div[data-flow-name]').html("").remove();
          });
          stepcontainer.find('.js-expire-cloud-link').click(function () {
            flowcontainer.html("").remove();
              $.get('/ra/expire_cloud_link/'+sid,function(response){
                if(response.ok)
                  self.fetchCloudShares();
                else
                  _this.text(_this.data('errorText'));
            })
          });
          if(sid){
            _this.text(txt);
              _this.removeClass('disabled');
          } else {
            _this.text(_this.data('errorText'));
          }
        });
      });
    }

    // render no activity

    if (el.find('.feed-table-interest .feed-row').length === 0){
      el.find('.feed-table-interest').append( templateFetcherSingleton.renderTemplate("no-activities") );
    } else {
      el.find('.collapsible-feed .header.pointer').addClass('expanded')
      el.find('.feed-table-interest').css('display', '');
    }

  };

  newestClientOverviewManager = self;
  this.init();
}

var emulateCheck = function (id) {
  var $toggle = $('.toggle:has(input#'+ id + ')'),
      checkval = $('#' + id).prop('checked') ? 1 : 0 ,
      b = checkval ? GREEN_BG : GREY_BG;
  $toggle.css('background-color', b);
  var c = checkval ? GREEN_TOGGLE : GREY_TOGGLE,
      $button = $toggle.find('.switcher-button');
  $button.css('background-color', c);
};

var emulateCheckByName = function(name, value) {
  var $toggle = $('.toggle:has(input[name="' + name + '"])'),
      b = value ? GREEN_BG : GREY_BG;
  $toggle.css('background-color', b);
  var c = value ? GREEN_TOGGLE : GREY_TOGGLE,
      $button = $toggle.find('.switcher-button');
  $button.css('background-color', c);
};

var alignHeaderOnLimitedHeightTable = function(elementWithTable) {
	var $tableHead = elementWithTable.find('thead'), $tableBody = elementWithTable.find('tbody');
	if ($tableHead.length && $tableBody.length) {
		var scrollbarWidth = $tableBody[0].offsetWidth - $tableBody[0].clientWidth
		$tableHead.css('padding-right', scrollbarWidth > 0 ? (scrollbarWidth + 'px') : '');
	}
}

var respondToVisibility = function(element, callback) {
  var options = {
    root: document.documentElement
  };

  var observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      callback(entry.intersectionRatio > 0);
    });
  }, options);

  observer.observe(element);
};
